/**
 * @author Cristyan Fernando Ballesteros
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.reportes': 'Reports',
  'sidebar.reportegeneral': 'General Report',
  'sidebar.ReporteBavaria': 'Remittance Report',
  'sidebar.reportebavaria': 'Remittance Report',
  'sidebar.reportemarcas': 'Brand Report',
  'sidebar.reporteinvmarcas': 'Regional Report Brands',
  'sidebar.inventariocoimpresores': 'Coimpresores Inventory Report',
  'sidebar.ReporteInventarioCoimpresores': 'Inventory Report',
  'sidebar.ReporteMovimiento': 'Movement Report',
  'sidebar.movimiento': 'Movement Report',
};
